function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { SvgIcon } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Translate = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsxs(SvgIcon, _extends({
    "data-testid": "TranslateIcon"
  }, props, {
    ref: ref,
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      d: "m10.412 22.98 2.797-4.74c.337-.428.5-.99.403-1.569L11.667 5H21a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H10.694c-.096 0-.19-.007-.282-.02zm10.296-10.13h.792v-1.222h-2.917V10h-1.166v1.628H14.5v1.222h.778a8.81 8.81 0 0 0 1.816 2.896c-.553.41-1.163.739-1.816.973V18a8.197 8.197 0 0 0 2.715-1.43A8.196 8.196 0 0 0 20.708 18v-1.28a7.062 7.062 0 0 1-1.817-.974 8.81 8.81 0 0 0 1.817-2.896zm-1.275 0a7.555 7.555 0 0 1-1.44 2.109 7.551 7.551 0 0 1-1.44-2.11h2.88z",
      clipRule: "evenodd",
      opacity: ".8"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      d: "M13.209 18.24 10.4 23c-.823 0-1.54-.56-1.74-1.358L8 19h3.64a2.002 2.002 0 0 0 1.569-.76z",
      clipRule: "evenodd",
      opacity: ".6"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      d: "M3 1h6.306a2 2 0 0 1 1.973 1.671l2.333 14A2 2 0 0 1 11.639 19H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm4.966 12.5H10l-2.274-7h-2.48L3 13.5h2.043l.348-1.306h2.236l.34 1.306zm-2.341-2.625h1.75L7.021 9.54c-.083-.297-.183-.681-.302-1.152a18.614 18.614 0 0 1-.233-1.013c-.034.19-.1.5-.2.935-.1.434-.32 1.289-.661 2.565z",
      clipRule: "evenodd"
    })]
  }));
});
Translate.displayName = 'TranslateIcon';
export default Translate;